<ng-container *ngIf="chats; else placeholder">
  <ng-container *ngIf="chats.size > 0">
    <i2g-chat-list-item
      *ngFor="let chat of chats"
      [name]="chat.name"
      [date]="chat.date"
      [message]="chat.message"
      class="chat-list-item"
    ></i2g-chat-list-item>
  </ng-container>

  <ng-container *ngIf="chats.size === 0">
    <i2g-empty-state
      class="empty-state"
      [icon]="emptyStateIcon"
      [description]="emptyStateDescription"
    ></i2g-empty-state>
  </ng-container>
</ng-container>

<ng-template #placeholder>
  <!-- NOTE: got error in build command when using pipe fill here -->
  <div class="placeholder-chat-list">
    <div class="placeholder shimmer"></div>
    <div class="placeholder shimmer"></div>
    <div class="placeholder shimmer"></div>
  </div>
</ng-template>
